
export default {
    drawer: true, 
    responsive: false,
    systemlogo: '../silica.png',
    gallerylogo: '../gallery.png',
    applogo: '/silica-text.png',
    main_arrow: '/arrow.png',
    is_logged: false,
    show_alert: false,
    overlay_loading: false,
    overlay_loading_text: '',
    alert_color: "secondary",
    alert_text: "No message",
    settings:[],
    availables:[],
    suppliers:[],
    products:[],
    trucks:[],
    users:[],
    drivers:[],
    categories:[],
    customertypes:[],
    customers:[],
    allowed_menus: {},
    menus: {
        mainmenu: [
          { title: 'Dashboard', icon: 'mdi-view-dashboard', path:'/dashboard'},
        ],
        operations: [
        { title: "Purchases", icon: 'mdi-file-multiple', path:'/purchase'},
          { title: "Deliveries", icon: 'mdi-truck-fast-outline', path:'/deliveries'},
        { title: "Sales", icon: 'mdi-dolly', path:'/sales'},
        { title: "Keeps & Borrowed", icon: 'mdi-door-closed-lock', path:'/keeps'},
        ],
        admin: [
          { title: 'Accounts', icon: 'mdi-account-tie', path:'/accounts'},
          { title: 'Trucks', icon: 'mdi-truck-check', path:'/trucks'},
          { title: "Products", icon: 'mdi-bottle-soda-classic', path:'/products'},
          { title: 'Customers', icon: 'mdi-account-group', path:'/customers'},
          { title: "Settings", icon: 'mdi-cogs', path:'/settings'},
        ],
        apps: [
          { title: 'Checker', icon: 'mdi-format-list-checks', path:'/checker/new'},
        ],
        reports: [
          { title: 'Merchandise', icon: 'mdi-file-table-box-multiple', path:'/merchandise-reports'},
          { title: 'Sales', icon: 'mdi-cash-register', path:'/sales-reports'},
          { title: 'DSIR', icon: 'mdi-text-box-multiple', path:'/inventory-reports'},
          { title: 'Stock Movement', icon: 'mdi-text-box-check', path:'/stock-movement'},
          { title: 'Outlet Monitoring', icon: 'mdi-storefront', path:'/outlet-monitoring'},
          { title: "Checker Reports", icon: 'mdi-truck-check-outline', path:'/delivery-reports'}
        ],
        accounting: [
        { title: "Acct. Receivables", icon: 'mdi-account-cash-outline', path:'/receivables'},
        { title: "Billing & Payments", icon: 'mdi-cash-multiple', path:'/payments'},
        { title: "Invoices", icon: 'mdi-receipt', path:'/invoices'},
        ],
      }
  }
  